const hljs = require('highlight.js');

import 'bootstrap';

import BitcoinMiner from './miners/bitcoin.worker.js';
import CustomMiner from './miners/custom.worker.js';

hljs.configure({
  useBR: true
});

// Do not use nonce.length > 9 - this will cause an error with out of range
// https://insight.bitpay.com/api/block/0000000000000000468ca627f7344ec59ec09618c23e3c5ea0b16be6660aba1c
// Solution is 603703914
$('code.bitcoin').html(hljs.fixMarkup(hljs.highlightAuto(`{
  "version": 2,
  "previousblockhash": "0000000000000000240f78ab8f3fc6c2f9142b9a4f973770271d6cc7568b9ec5",
  "merkleroot": "2627ce0dcfc19c7399385e60fc2a8377c6a0de47f77e6264533157266d20e304",
  "time": 1398076184,
  "bits": "19009d8c",
  "initialNonce": 603702914
}`).value));

// CoinHive key
$('code.monero').html('CoinHive is dead 💀');

$('code.custom').html(hljs.fixMarkup(hljs.highlightAuto(`{
  "index": 1,
  "difficulty": 3,
  "data": {
    "amount": 4
  }
}`).value));

let elements = {};
elements.run = $('.play');
elements.run.on('click', function() {
  let currency = $(this).data('currency');

  if ($(this).data('started')) {
    stop(currency);
  } else {
    // Clear chart data
    for (let i = 0; i < chart.options.data.length; i++) {
      chart.options.data[i].dataPoints.length = 0;
    }

    chart.render();

    $('.stats.' + currency).find('.result').remove();

    switch ($(this).data('currency')) {
      case 'bitcoin':
        startBitcoin();
      break;

      case 'monero':
        startMonero();
      break;

      case 'custom':
        startCustom();
      break;
    }

    toggleButton($(this));
  }
});

const stop = function stop(currency) {
  for (let miner in threads) {
    if (miner === currency) {
      if (currency === 'monero') {
        threads[miner].stop();
        window.clearInterval(window.moneroStats);
      } else {
        threads[miner].terminate();
      }
    }
  }

  toggleButton($('.play[data-currency=' + currency + ']'));
};

const toggleButton = function toggleButton(button) {
  const $icon = $(button).find('.fa');
  $icon.toggleClass('fa-start fa-stop');

  if ($(button).attr('data-started') === undefined) {
    $(button).attr('data-started', '');
  }

  if ($icon.hasClass('fa-start')) {
    $(button).data('started', true);
    $(button).contents().last()[0].textContent = 'Остановить';
  } else {
    $(button).data('started', false);
    $(button).contents().last()[0].textContent = 'Запустить';
  }
};

const getCode = function (currency) {
  return JSON.parse($('code.' + currency).html().replace(/<(?:.|\n)*?>/gm, ''))
};

let threads = {};
const startBitcoin = function startBitcoin() {
  threads.bitcoin = new BitcoinMiner();

  threads.bitcoin.onmessage = messageHandler;
  threads.bitcoin.onerror = errorHandler;

  threads.bitcoin.postMessage(getCode('bitcoin'));
};

const startMonero = function startMonero() {
  threads.monero = new CoinHive.Anonymous(getCode('monero').key, {
    throttle: 0.3
  });

  const currency = 'monero';

  threads.monero.start();

  threads.monero.on('found', function () {
    messageHandler({
      data: {
        currency: currency,
        type: 'solve',
        hps: Math.trunc(threads.monero.getHashesPerSecond()),
        hashes: threads.monero.getTotalHashes()
      }
    });
  });

  threads.monero.on('accepted', function () {
    messageHandler({
      data: {
        currency: currency,
        type: 'accepted',
        hps: Math.trunc(threads.monero.getHashesPerSecond()),
        hashes: threads.monero.getTotalHashes()
      }
    });
  });

  threads.monero.on('job', function () {
    messageHandler({
      data: {
        currency: currency,
        type: 'job',
        hps: Math.trunc(threads.monero.getHashesPerSecond())
      }
    });
  });

  // Отправка статистики каждую секунду
  window.moneroStats = window.setInterval(function () {
    messageHandler({
      data: {
        currency: currency,
        type: 'status',
        hps: Math.trunc(threads.monero.getHashesPerSecond()),
        hashes: threads.monero.getTotalHashes()
      }
    });
  }, 1000);
};

const startCustom = function startCustom() {
  threads.custom = new CustomMiner();

  threads.custom.onmessage = messageHandler;
  threads.custom.onerror = errorHandler;

  threads.custom.postMessage(getCode('custom'));
};

let dps = {};
const chart = new CanvasJS.Chart('chart', {
  theme: 'light2',
  axisX: {
    title: 'Timeline',
    gridThickness: 1,
    valueFormatString: 'mm:ss',
  },
  axisY: {
    title: 'Nonces',
    includeZero: false
  },
  data: [{
    type: 'line',
    lineColor: '#f7931a',
    markerColor: '#f7931a',
    dataPoints: dps.bitcoin = []
  }, {
    type: 'line',
    lineColor: '#f56a3f',
    markerColor: '#f56a3f',
    dataPoints: dps.monero = []
  }, {
    type: 'line',
    lineColor: '#343a40',
    markerColor: '#343a40',
    dataPoints: dps.custom = []
  }]
});

const dataLength = 10000; // Number of dataPoints visible at any point
const messageHandler = function messageHandler(e) {
  let $stats = $('.stats.' + e.data.currency);

  switch (e.data.type) {
    case 'status':
      $stats.find('.hps').html(e.data.hps + ' h/s');

      if (e.data.nonce) {
        $stats.find('.current').html('Nonce: ' + e.data.nonce);
      } else {
        $stats.find('.current').html('Hashes: ' + e.data.hashes);
      }

      chart.options.axisY.title = e.data.nonce ? 'Nonce' : 'Hashes';

      dps[e.data.currency].push({
        x: new Date(),
        y: e.data.nonce ? e.data.nonce : e.data.hashes
      });

      if (dps[e.data.currency].length > dataLength) {
        dps[e.data.currency].shift();
      }
    break;

    case 'solve':
      if (e.data.nonce) {
        $stats.append('<button class="btn result btn-success">Solution found on nonce ' + e.data.nonce + '</button>');
      }

      dps[e.data.currency].push({
        x: new Date(),
        y: e.data.nonce ? e.data.nonce : e.data.hashes,
        indexLabel: 'Solved',
        markerSize: 10,
        markerColor: '#1e7e34',
        markerType: 'square'
      });

      if (e.data.currency !== 'monero') {
        stop(e.data.currency);
      }
    break;

    case 'accepted':
      dps[e.data.currency].push({
        x: new Date(),
        y: e.data.hashes,
        indexLabel: 'Accepted',
        markerSize: 10,
        markerColor: '#ffe520',
        markerType: 'triangle'
      });
    break;

    case 'job':
      dps[e.data.currency].push({
        x: new Date(),
        y: e.data.hashes,
        indexLabel: 'New Job',
        markerSize: 10,
        markerColor: '#426bf4',
        markerType: 'cross'
      });
    break;

    case 'finished':
      $stats.append('<button class="btn result btn-danger">Finished (last nonce)</button>');

      dps[e.data.currency].push({
        x: new Date(),
        y: e.data.nonce,
        indexLabel: 'Finish',
        markerSize: 10,
        markerColor: '#dc3545',
        markerType: 'cross'
      });

      stop(e.data.currency);
    break;
  }

  chart.render();
};

const errorHandler = function errorHandler(e) {
  console.log('Error: ', e);
};

$('#reload').click(function() {
  window.location.reload();
});